module.exports = __webpack_public_path__ + "img/reveal-small.ceeaf7f0.svg";